export default __webpack_public_path__ + "media/zurb/img/about/culture/culture-img9-8e5294c83f7bd093e83d3b715b2022b9.jpg";